import { render, staticRenderFns } from "./TaskChangeComponentSelector.vue?vue&type=template&id=7cf53e39&scoped=true&lang=pug&"
import script from "./TaskChangeComponentSelector.vue?vue&type=script&lang=js&"
export * from "./TaskChangeComponentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf53e39",
  null
  
)

export default component.exports